import { Component } from 'react';
import Raven from 'raven-js';
class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      error: false
    };
  }
  static getDerivedStateFromError() {
    return {
      error: true
    };
  }
  componentDidCatch(error, info) {
    Raven.captureException(error, {
      extra: {
        info
      }
    });
  }
  render() {
    if (this.state.error) {
      return null;
    }
    return this.props.children;
  }
}
export default ErrorBoundary;